<template>
    <div>
        <p class="listLength">共计 <span>{{Total}}条</span></p>
        <LoadingFooter :finished="finished" v-model='loading' @load="onLoad" @scroll="$Bus.$emit('IsSee',false)">
            <div style="padding-top: 8vw;">
                <div class="items IsLoad" v-for="(item, index) in list" @click="pageLoad(item)">
                    <div class="itemTopBox">
                        <div>
                            <span>单号</span>
                            <span>{{item.DH}}</span>
                        </div>
                        <div>
                            <span>编号</span>
                            <span>{{item.HTBH}}</span>
                        </div>
                        <div>
                            <span>设备名称</span>
                            <span>{{item.SBMC}}</span>
                        </div>
                        <div>
                            <span>规格型号</span>
                            <span>{{item.SBGG}}</span>
                        </div>
                        <div>
                            <span>数量</span>
                            <span>{{item.SL}}</span>
                        </div>
                        <div>
                            <span>设备单价</span>
                            <span>{{item.CGDJ}}</span>
                        </div>
                        <div>
                            <span>总金额</span>
                            <span>{{item.ZJE}}</span>
                        </div>
                        <div>
                            <span>供应商</span>
                            <span>{{item.GYSMC}}</span>
                        </div>
                        <div>
                            <span>生产厂家</span>
                            <span>{{item.SCQYMC}}</span>
                        </div>
                    </div>
                    <div class="itemBottomBox">
                        <div v-show='IsSee'>修改</div>
                        <div @click.stop="SubmitAcceptance(item,index)">{{YSBZ=='0'?'提交':'回撤验收'}}</div>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <div class="menu" key="0" v-show="IsSee">
                    <Field title="合同名称" placeholder="请输入" :text='search.HTMC'
                        @onMessage="value => search.HTMC = value" />
                    <Field title="供应商" placeholder="请输入供应商编号或名称" :text='search.GYSMC'
                        @onMessage="value => search.GYSMC = value" />
                    <Field title="设备名称" placeholder="请输入设备名称" :text='search.SBMC'
                        @onMessage="value => search.SBMC = value" />
                    <Field title="开始时间" placeholder="请选择" type="calendar" :text='search.StartDate'
                        @onMessage="value => search.StartDate = value" />
                    <Field title="结束时间" placeholder="请选择" type="calendar" :text='search.EndDate'
                        @onMessage="value => search.EndDate = value" />
                    <div class="search" @click="serach">查询</div>
                </div>
            </transition>
        </LoadingFooter>
    </div>
</template>
<script>
    import Field from '../field/field'
    import LoadingFooter from '../loadingFooter/loadingFooter'
    export default {
        name: 'Acceptance',
        components: {
            Field,
            LoadingFooter
        },
        props: {
            YSBZ: {
                type: String,
                default: '1'
            }
        },
        data() {
            return {
                list: [],
                Total: 0,
                Button: false,
                pageIndex: 1,
                search: {
                    HTMC: '',
                    GYSMC: '',
                    SBMC: '',
                    StartDate: '',
                    EndDate: '',
                },
                SecondText: '11111',
                loading: true,
                finished: false,
                ThirdlyText: '1245',
                IsSee: false
            }
        },
        // beforeDestroy() {
        //     this.list = [];
        //     this.$Bus.$off('IsSee');
        // },
        mounted() {
            this.loading = true;
            this.finished = false;
            this.list = [];
            this.loadDataDefault();
        },
        methods: {
            loadDataDefault() {
                this.$post('api/CheckIncoming/PutInOrAuditList', {
                    PageIndex: this.pageIndex,
                    PageSize: 10,
                    StartDate: this.search.StartDate,
                    EndDate: this.search.EndDate,
                    HTMC: this.search.HTMC,
                    GYSMC: this.search.GYSMC,
                    SBMC: this.search.SBMC,
                    YSBZ: this.YSBZ,
                    SHBZ: '0',
                    Store: this.$UserInfo.StoreCode,
                    Token: '123456789'
                }).then(result => {
                    this.Total = result.Total;
                    var that = this;
                    result.PutInOrAuditList.map((item) => {
                        that.list.push(item);
                    })
                    if ((this.pageIndex * 10) >= result.Total) {
                        this.loading = false;
                        this.finished = true;
                    } else this.loading = false;
                })
            },
            serach() {
                this.list = [];
                this.pageIndex = 1;
                this.loadDataDefault();
                this.$Bus.$emit('IsSee', false)
            },
            SubmitAcceptance(item, index) { //删除入库单
                this.$Dialog.confirm({
                    message: '是否提交信息?提交后无法修改!'
                }).then(() => {
                    this.$post('api/CheckIncoming/AuditAcceptance', {
                        YSDH: item.DH,
                        SubmitType: item.YSBZ == 0 ? 1 : 2
                    }).then(result => {
                        if (result.Status) {
                            this.$Toast({
                                message: '操作成功!',
                                duration: 1500,
                                onClose: () => {
                                    this.Total -= 1;
                                    this.list.splice(index, 1)
                                }
                            });
                        } else this.$Toast(result.Msg);
                    })
                }).catch(() => {});
            },
            AuditPutInForm(item, index) { //审核操作
                this.$Dialog.confirm({
                    message: `确定审核单号【${item.DH}】?`
                }).then(() => {
                    this.$get('api/CheckIncoming/AuditPutInForm', {
                        Token: '123456',
                        DH: item.DH,
                        SBBH: item.SBMCBH
                    }).then(result => {
                        if (result.Status) {
                            this.$Toast({
                                message: '审核成功!',
                                duration: 1500,
                                onClose: () => {
                                    this.list.splice(index, 1);
                                    this.Total -= 1;
                                }
                            });
                        } else this.$Toast(result.Msg);
                    })
                }).catch(() => {});
            },
            pageLoad(item) { //修改
                this.$get('api/CheckIncoming/LoadPutInInfo', {
                    Token: 'YTDF5EF3A6174564E5981A446158F106',
                    DH: item.DH,
                    SBBH: item.SBMCBH,
                }).then(result => {
                    let requestData = result.PutInInfoList[0];
                    this.AcceptanceInfoList = result.PutInInfoList[0];
                    this.AcceptanceInfoList.GLLB = '';
                    this.AcceptanceInfoList.LSBH = this.$UserInfo.UserId + this.$format(new Date(),
                        'YYYYMMDDHHmmss');
                    this.AcceptanceInfoList.ZJE = item.ZJE; //api未返回zje字段，取列表出字段zje
                    this.$router.push({
                        name: 'EquipmentAcceptanceDetails',
                        params: {
                            AcceptanceInfoList: this.AcceptanceInfoList,
                            AZYS: (result.PutInInfoList[0].AZYSQK || '').split(','), //安装验收复选框
                            IsAddOrUpdata: true,
                            PageState: this.ThirdlyText === '详情' ? true : false,
                        }
                    })
                })
            },
            onLoad() { //触底操作
                if (!this.finished && !this.loading) {
                    this.loading = true;
                    this.pageIndex += 1;
                    this.loadDataDefault();
                }
            }
        },
        watch: {
            YSBZ(value) {
                this.pageIndex = 1;
                this.loading = true;
                this.finished = false;
                this.list = [];
                this.loadDataDefault();
            },
            $route(to, from) {
                if (from.name == 'EquipmentAcceptanceDetails' || from.name == 'StorageEquipment') {
                    this.PageIndex = 1;
                    this.list = [];
                    this.loadDataDefault();
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        margin-top: 12vw;
        box-sizing: border-box;
        margin-bottom: 20px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding: 36px 30px;

        .itemTopBox {
            border-bottom: 2px solid #eee;

            div {
                display: flex;
                align-items: center;
                font-size: 28px;
                margin-bottom: 32px;

                span:first-child {
                    flex: 1;
                    color: #858585;
                }

                span:last-child {
                    color: $TEXT-DARK-COLOR;
                    font-weight: bold;
                    width: 326px;
                    text-align: right;
                }
            }
        }

        .itemBottomBox {
            margin-top: 32px;
            display: flex;
            align-items: center;
            justify-content: center;

            div {
                width: 200px;
                height: 80px;
                border-radius: 8px;
                text-align: center;
                line-height: 80px;
                font-size: 26px;
                margin-right: 42px;

                &:first-child {
                    background: #dedede;
                    color: #858585;
                }

                &:nth-child(2) {
                    background: $THEME-COLOR;
                    color: #fff;
                }

                &:last-child {
                    background: $THEME-COLOR;
                    color: #fff;
                    margin-right: 0;
                }
            }
        }
    }

    .listLength {
        top: 25vw !important;
        font-size: 29px;
        color: #4a4a4a;
        margin-bottom: -580px;
        margin-left: 30px;
        transition: all .5s;

        span {
            margin-left: 20px;
            color: $THEME-COLOR;
            font-weight: bold;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Acceptance/Acceptance.vue